import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49c242c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["size", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "icomoon-loading"
}




export default /*#__PURE__*/_defineComponent({
  props: {
    size: null,
    icon: null,
    text: null,
    type: null,
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  size?: 'large' | 'small' |  'middle' | 'default'
  icon?: string
  text: string
  type?: 'primary' | 'cancel'
  disabled?:boolean
  loading?:boolean
}






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["hezi-button", props.type || 'primary']),
    size: props.size || 'default',
    disabled: props.disabled || props.loading
  }, [
    (!!props.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true),
    (!!props.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(props.icon)
        }, null, 2))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(props.text), 1)
  ], 10, _hoisted_1))
}
}

})